/* import __COLOCATED_TEMPLATE__ from './notification-rule-assignee-select-item.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import { readOnly, and } from '@ember/object/computed';
import Component from '@ember/component';
export default Component.extend({
  classNames: ['dropdown__list-item'],
  classNameBindings: ['isActive:o__selected'],
  attributeBindings: ['data-test-notification-assignee-item'],
  'data-test-notification-assignee-item': readOnly('admin.id'),
  click() {
    this.itemAction(this.admin);
  },
  notAllTeams: and('admin', 'admin.id'),
});
